var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{class:_vm.loadingClass,style:(_vm.loadingStyle)},[_vm._m(0)]):(_vm.isEmpty)?_c('div',[_c('p',{staticStyle:{"margin-bottom":"0px","padding-top":"10px","padding-bottom":"10px","margin-left":"5px"}},[_vm._v(" "+_vm._s(_vm.$t('NotFoundOrder'))+" ")])]):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('span',{staticClass:"loader"})])
}]

export { render, staticRenderFns }